import { faHandshake } from '@fortawesome/free-solid-svg-icons';
import { Collapse, ListItemText } from '@mui/material';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router';

import { tradingSlice } from '!views/index';
import { useIsAbleToProceed } from '»utils/customHooks';

import {
  FontAwesomeIconStyled,
  getActiveMenuItemSelector,
  menusSlice,
} from '..';
import {
  LeafListItemButtonStyled,
  LeafListItemTextStyled,
  ListItemIconStyled,
  ListStyled,
  RootListItemButtonStyled,
} from '../Menu.styles';
import {
  getActiveNavigationMenuItemSelector,
  getMainMenu,
  isMenuOpened,
} from '../menus.selectors';

export const TradingMenuItem = () => {
  const dispatch = useDispatch();

  const activeMenuItem = useSelector(getActiveMenuItemSelector);
  const activeNavigationMenuItem = useSelector(
    getActiveNavigationMenuItemSelector,
  );
  const isOpen = useSelector(isMenuOpened);
  const mainMenu = useSelector(getMainMenu);

  const available = mainMenu.some(
    (menuOption) => menuOption.optionId === 'TRLT_TRADING',
  );
  const availablePrimary = mainMenu.some(
    (menuOption) => menuOption.optionId === 'TRLT_TRADING_PRIMARY',
  );
  const availableStockExchange = mainMenu.some(
    (menuOption) => menuOption.optionId === 'TRLT_TRADING_STOCK_EXCHANGE',
  );
  const availableFunds = mainMenu.some(
    (menuOption) => menuOption.optionId === 'TRLT_TRADING_FUNDS',
  );

  const OPTION_ID = 'TRADING';
  const LEAF_OPTION_ID1 = 'PRIMARY';
  const LEAF_OPTION_ID2 = 'BOLSA';
  const LEAF_OPTION_ID3 = 'FUNDS';

  const { isAbleToProceed } = useIsAbleToProceed();

  const handleClickLeafMenu = (event, menuItem) => {
    isAbleToProceed(event, () => {
      if (menuItem !== activeMenuItem) {
        dispatch(
          menusSlice.actions.setActiveMenuItem({ activeMenuItem: menuItem }),
        );
        dispatch(tradingSlice.actions.setCurrentTab(0));
      }
    });
  };

  const handleClickRootMenu = (menuItem) => {
    dispatch(
      menusSlice.actions.setActiveNavigationMenuItem({
        activeNavigationMenuItem: menuItem,
      }),
    );
  };

  if (!available) return null;

  return (
    <>
      <RootListItemButtonStyled
        onClick={() => handleClickRootMenu(OPTION_ID)}
        selected={activeMenuItem?.includes(OPTION_ID)}
        opened={activeNavigationMenuItem.includes(OPTION_ID)}
        isOpen={isOpen}
        id="btnMenuTrading"
      >
        <ListItemIconStyled>
          <FontAwesomeIconStyled
            icon={faHandshake}
            selected={activeMenuItem?.includes(OPTION_ID)}
          />
        </ListItemIconStyled>
        <ListItemText primary={<FormattedMessage id="TRLT_UI-ORDERS" />} />
      </RootListItemButtonStyled>
      <Collapse
        in={activeNavigationMenuItem.includes(OPTION_ID)}
        timeout="auto"
        unmountOnExit
      >
        <ListStyled
          component="div"
          disablePadding
          selected={activeMenuItem?.includes(OPTION_ID)}
          opened={activeNavigationMenuItem.includes(OPTION_ID)}
        >
          {availableStockExchange && (
            <LeafListItemButtonStyled
              onClick={(event) =>
                handleClickLeafMenu(event, `${OPTION_ID}:${LEAF_OPTION_ID2}`)
              }
              component={Link}
              to="/Trading/StockExchange"
              selected={activeMenuItem?.includes(
                `${OPTION_ID}:${LEAF_OPTION_ID2}`,
              )}
              id="btnMenuTradingSecondary"
              isOpen={isOpen}
            >
              <LeafListItemTextStyled
                primary={
                  isOpen ? (
                    <FormattedMessage id="TRLT_UI-EXCHANGE" />
                  ) : (
                    <FormattedMessage id="TRLT_UI-EXCHANGE_SHORT" />
                  )
                }
                selected={activeMenuItem?.includes(
                  `${OPTION_ID}:${LEAF_OPTION_ID2}`,
                )}
                isOpen={isOpen}
              />
            </LeafListItemButtonStyled>
          )}
          {availablePrimary && (
            <LeafListItemButtonStyled
              onClick={(event) =>
                handleClickLeafMenu(event, `${OPTION_ID}:${LEAF_OPTION_ID1}`)
              }
              component={Link}
              to="/Trading/Primary"
              selected={activeMenuItem?.includes(
                `${OPTION_ID}:${LEAF_OPTION_ID1}`,
              )}
              id="btnMenuTradingPrimary"
              isOpen={isOpen}
            >
              <LeafListItemTextStyled
                primary={
                  isOpen ? (
                    <FormattedMessage id="TRLT_UI-PRIMARY" />
                  ) : (
                    <FormattedMessage id="TRLT_UI-PRIMARY_SHORT" />
                  )
                }
                selected={activeMenuItem?.includes(
                  `${OPTION_ID}:${LEAF_OPTION_ID1}`,
                )}
                isOpen={isOpen}
              />
            </LeafListItemButtonStyled>
          )}
          {availableFunds && (
            <LeafListItemButtonStyled
              onClick={(event) =>
                handleClickLeafMenu(event, `${OPTION_ID}:${LEAF_OPTION_ID3}`)
              }
              component={Link}
              to="/Trading/Funds"
              selected={activeMenuItem?.includes(
                `${OPTION_ID}:${LEAF_OPTION_ID3}`,
              )}
              id="btnMenuTradingFunds"
              isOpen={isOpen}
            >
              <LeafListItemTextStyled
                primary={<FormattedMessage id="TRLT_UI-FUNDS" />}
                selected={activeMenuItem?.includes(
                  `${OPTION_ID}:${LEAF_OPTION_ID3}`,
                )}
                isOpen={isOpen}
              />
            </LeafListItemButtonStyled>
          )}
        </ListStyled>
      </Collapse>
    </>
  );
};

TradingMenuItem.propTypes = {
  isOpen: PropTypes.bool,
  activeMenuItem: PropTypes.string,
  available: PropTypes.bool,
  availablePrimary: PropTypes.bool,
  availableStockExchange: PropTypes.bool,
  setActiveMenuItem: PropTypes.func,
  activeNavigationMenuItem: PropTypes.string,
  setActiveNavigationMenuItem: PropTypes.func,
  availableFunds: PropTypes.bool,
};
